import axios from 'axios';

const insightsAPI = {
  getInsights() {
    return axios.get('/api/insights');
  },

  getInsight(id) {
    return axios.get(`/api/insights/${id}`);
  },

  createInsight(insight) {
    return axios.post('/api/insights', insight);
  },

  updateInsight(id, insight) {
    return axios.put(`/api/insights/${id}`, insight);
  },

  deleteInsight(id) {
    return axios.delete(`/api/insights/${id}`);
  },

  executeInsight(id, startTime, endTime) {
    const params = {};
    if (startTime) params.start_time = startTime;
    if (endTime) params.end_time = endTime;
    return axios.get(`/api/insights/${id}/execute`, { params });
  },
};

export default insightsAPI;

